import { Component, Input, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import * as moment from 'moment/moment';
import {MenuHomeEnum} from 'app/home';
import {PayoutTransactionOnlineTransferEnum} from 'app/models/transaction/payout-transaction-online-transfer.enum';
import {CampaignUsersService} from 'app/services/campaign-users.service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { RiderVehicleTypeEnum, ServiceAndVehicleTypeModel } from 'app/models';
import { FieldTypeEnum } from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'campaign-users-transactions',
    templateUrl: './campaign-users-transactions.component.html',
    styleUrls: ['./campaign-users-transactions.component.scss'],
    providers: [MessageService]
})

export class CampaignUsersTransactionsComponent implements AfterViewInit  {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public campaignUsersTabMenu: Array<any> = [];

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    companyTransactions: Array<any> = [];
    arrayFilterStatuses: any =
    [
        {
            name: 'All', value: null
        },
        {
            name: 'Pending', value: PayoutTransactionOnlineTransferEnum.Completed
        },
        {
            name: 'Cancelled', value: PayoutTransactionOnlineTransferEnum.Cancelled
        },
        {
            name: 'Completed', value: PayoutTransactionOnlineTransferEnum.Pending
        }
    ];
    cols: any[] = [
        {
            field: 'DeliveryOrderId',
            header: 'Booking ID',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'DeliveryOrderId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'TransactionId',
            header: 'TX Id',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'TransactionId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'CreatedAtDateText',
            header: 'TX Date',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'CreatedAtDateText',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'CreatedAtTimeText',
            header: 'TX Time',
            width: '10%',
            fieldType: FieldTypeEnum.CalendarTime,
            model: 'CreatedAtTimeText',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'RiderId',
            header: 'Driver ID',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'RiderId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'UserId',
            header: 'User ID',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'UserId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'Status',
            header: 'TX Status',
            width: '10%',
            disableSort: false,
            fieldType: FieldTypeEnum.Dropdown,
            model: 'Status',
            options: this.arrayFilterStatuses,
            placeholder: 'Please Select',
            action: (rowData: any) => this.getStatusStyles(rowData),
            active: false
        },
        {
            field: 'ServiceTypeAndVehicleTypeText',
            header: 'Services',
            width: '10%',
            fieldType: FieldTypeEnum.Dropdown,
            model: 'VehicleType',
            options: ServiceAndVehicleTypeModel.GetServiceAndVehicleTypeList,
            take: 'obj',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'AmountText',
            header: 'Amount',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'AmountText',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'PaymentType',
            header: 'Payment Type',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'PaymentType',
            placeholder: 'Type here',
            active: false
        },
    ];
    rowsPerPage: number = 13;
    totalRecords: number = -1;
    fieldTypeEnum = FieldTypeEnum;
    paginator: Paginator = new Paginator();
    visibleTransactionsFilter: boolean = false;
    filterObj: any = {
        startDate: null,
        endDate: null,
        digitType: null,
        payService: null
    };
    txnHeaderSearch: any = {
        TransactionId: null,
        DeliveryOrderId: null,
        CreatedAt: null,
        CreatedAtDateText: null,
        CreatedAtTimeText: null,
        RiderId: null,
        AmountText: null,
        VehicleType: null,
        Status: null,
        PaymentType: null,
    };
    first: number = 0;
    sortField: string | string[] = 'DeliveryOrderId';
    sortOrder: number = -1;
    loading: boolean = false;
    searchTimer: number = 0;
    showDetailTransactionSidebar: boolean = false;
    selectedTransaction: any;

    menuHomeEnumActive: MenuHomeEnum = MenuHomeEnum.CampaignUsers_Transactions;
    selectedColumns: any[] = [];
    tableName: string = EditTableConfig.CAMPAIGN_USERS_TRANSACTIONS;

    constructor(
        private messageService: MessageService,
        private campaignUsersService: CampaignUsersService,
        public configService: ConfigService,
        private cdRef: ChangeDetectorRef) {
            this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }
    }

    getMenuHomeName(): string {
        return this.campaignUsersTabMenu.find((item: any) => item.value === this.menuHomeEnumActive)?.name;
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'DeliveryOrderId';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.callGridTitles(skip);
    }

    filter: {
        searchName: string;
    } = { searchName: '' };

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'DeliveryOrderId') {
                this.txnHeaderSearch.id = event.target.value;
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    getPayoutTransactions(skip: number) {
        const dto = {
            TransactionId: this.txnHeaderSearch.TransactionId ? this.txnHeaderSearch.TransactionId : null,
            DeliveryOrderId: this.txnHeaderSearch.DeliveryOrderId ? this.txnHeaderSearch.DeliveryOrderId : null,
            CreatedAtDateText: this.txnHeaderSearch.CreatedAtDateText ? moment(this.txnHeaderSearch.CreatedAtDateText).format('YYYY-MM-DDTHH:mm:ss') : null,
            CreatedAtTimeText: this.txnHeaderSearch.CreatedAtTimeText ? moment(this.txnHeaderSearch.CreatedAtTimeText).format('YYYY-MM-DDTHH:mm:ss') : null,
            RiderId: this.txnHeaderSearch.RiderId ? this.txnHeaderSearch.RiderId : null,
            UserId: this.txnHeaderSearch.UserId ? this.txnHeaderSearch.UserId : null,
            VehicleType: this.txnHeaderSearch.VehicleType && this.txnHeaderSearch.VehicleType.vehicleType ? this.txnHeaderSearch.VehicleType.vehicleType : null,
            Amount: this.txnHeaderSearch.AmountText ? this.txnHeaderSearch.AmountText : null,
            Status: this.txnHeaderSearch.Status ? this.txnHeaderSearch.Status : null,
            PaymentType: this.txnHeaderSearch.PaymentType ? this.txnHeaderSearch.PaymentType : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.loading = true;

        this.campaignUsersService.getCompanyTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.paginator.Items = [];
                this.paginator.Items.push(...data.CompanyTransactions);
                this.companyTransactions = this.formatCompanyTransactions(data.CompanyTransactions);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    formatCompanyTransactions(companyTransactions: any): any {
        companyTransactions.map((item: any) => {
            item.CreatedAtTimeText =
                item.CreatedAt ? moment(Utils.utcToLocalDate(item.CreatedAt)).format('h:mm A') : '';
            item.CreatedAtDateText =
                item.CreatedAt ? moment(Utils.utcToLocalDate(item.CreatedAt)).format('DD/MM/YYYY') : '';
            return item;
        });
        return companyTransactions;
    }

    onSelectionChange(event: any) {
        this.selectedTransaction = event?.data;
    }

    handleHideTransactionInfo() {
        this.showDetailTransactionSidebar = false;
    }

    callGridTitles(skip: number) {
        this.callPayoutTransactions(skip);
    }

    callPayoutTransactions(skip: number) {
        this.getPayoutTransactions(skip);
    }
    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    handleShowTransactionInfo(transaction: any) {
        this.selectedTransaction = transaction;
        this.showDetailTransactionSidebar = true;
    }

    updateEventEmit(value: any) {
        this.showDetailTransactionSidebar = false;
        this.callGridTitles(0);
    }

    getStatusStyles(status: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status?.Status) {
            case 'Completed':
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case 'Pending':
                backgroundColor = '#FFEFCC';
                textColor = '#FFB100';
                break;
            case 'Cancelled':
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }
}

class Paginator {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
}
